import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutCommissionableMarginQuickInfo extends Layout {
    labelCommissionable: Label;
    labelExclusions: Label;
    labelOtherCharges: Label;
    labelPayAdjustments: Label;
    labelTotalCarrierPay: Label;
    labelTotalCharges: Label;
    sourceCommissionableMargin: DataSource;
    textboxCarrierPay: Label;
    textboxExcludedOtherCharges: Label;
    textboxExcludedPayAdjustments: Label;
    textboxTotalRevenue: Label;
}
